'use client';

import { c as _c } from "react/compiler-runtime";
import { mergeClasses } from 'minimal-shared/utils';
import { styled } from '@mui/material/styles';
import GlobalStyles from '@mui/material/GlobalStyles';
import { layoutClasses } from './classes';
import { layoutSectionVars } from './css-vars';

// ----------------------------------------------------------------------

export function LayoutSection(t0) {
  const $ = _c(30);
  let children;
  let className;
  let cssVars;
  let footerSection;
  let headerSection;
  let other;
  let sidebarSection;
  let sx;
  if ($[0] !== t0) {
    ({
      sx,
      cssVars,
      children,
      footerSection,
      headerSection,
      sidebarSection,
      className,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = cssVars;
    $[4] = footerSection;
    $[5] = headerSection;
    $[6] = other;
    $[7] = sidebarSection;
    $[8] = sx;
  } else {
    children = $[1];
    className = $[2];
    cssVars = $[3];
    footerSection = $[4];
    headerSection = $[5];
    other = $[6];
    sidebarSection = $[7];
    sx = $[8];
  }
  let t1;
  if ($[9] !== cssVars) {
    t1 = <GlobalStyles styles={theme => ({
      body: {
        ...layoutSectionVars(theme),
        ...cssVars
      }
    })} />;
    $[9] = cssVars;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  const inputGlobalStyles = t1;
  let t2;
  if ($[11] !== className) {
    t2 = mergeClasses([layoutClasses.root, className]);
    $[11] = className;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== sx) {
    t3 = Array.isArray(sx) ? sx : [sx];
    $[13] = sx;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== t3) {
    t4 = [...t3];
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== children || $[18] !== footerSection || $[19] !== headerSection || $[20] !== sidebarSection) {
    t5 = sidebarSection ? <>{sidebarSection}<LayoutSidebarContainer className={layoutClasses.sidebarContainer}>{headerSection}{children}{footerSection}</LayoutSidebarContainer></> : <>{headerSection}{children}{footerSection}</>;
    $[17] = children;
    $[18] = footerSection;
    $[19] = headerSection;
    $[20] = sidebarSection;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] !== other || $[23] !== t2 || $[24] !== t4 || $[25] !== t5) {
    t6 = <LayoutRoot id="root__layout" className={t2} sx={t4} {...other}>{t5}</LayoutRoot>;
    $[22] = other;
    $[23] = t2;
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  let t7;
  if ($[27] !== inputGlobalStyles || $[28] !== t6) {
    t7 = <>{inputGlobalStyles}{t6}</>;
    $[27] = inputGlobalStyles;
    $[28] = t6;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  return t7;
}
const LayoutRoot = styled('div')``;
const LayoutSidebarContainer = styled('div')(() => ({
  display: 'flex',
  flex: '1 1 auto',
  flexDirection: 'column'
}));